import { RouteConfig } from "vue-router";
import Vue from "vue";
import Router from "vue-router";
import authGuard from "./auth-guard";
import PageNotFound from "shared/global/pages/PageNotFound.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
});

router.beforeEach(authGuard);

export default router;

export const setRoutes = (routes: RouteConfig[]): void => {
  router.addRoutes(routes);
  router.addRoutes([
    {
      path: "*",
      component: PageNotFound,
    },
  ]);
};
